// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"83e2195a","400":"f6e154e7","563":"a13f53ca","570":"83e2195a","582":"16bbdfe7","683":"2eff4661"}[chunkId] + ".chunk.css";
};